import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.historicDataList, { type, payload }) {
    switch (type) {
        case types.PATIENT_HISTORIC_DATA_LIST_REQUEST:
            return {
                ...initialState.historicDataList,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.PATIENT_HISTORIC_DATA_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.PATIENT_HISTORIC_DATA_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}